import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, isRef as _isRef, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c4bed90"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "packageInfoWrapper"
}
const _hoisted_2 = { class: "packageInfo" }
const _hoisted_3 = { class: "infoItem top" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "套餐名称", -1))
const _hoisted_5 = { class: "fixText" }
const _hoisted_6 = { class: "infoItem" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "套餐特点", -1))
const _hoisted_8 = { class: "fixText infoRight" }
const _hoisted_9 = { class: "infoItem" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "套餐流量", -1))
const _hoisted_11 = { class: "fixText infoRight" }
const _hoisted_12 = { class: "infoItem" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "套餐原价", -1))
const _hoisted_14 = { class: "fixText infoRight originalPrice" }
const _hoisted_15 = { class: "infoItem priceText" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "套餐售价", -1))
const _hoisted_17 = { class: "fixText" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "remark" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "remarkText" }, [
    /*#__PURE__*/_createTextVNode(" ·本服务充值后不支持退款、提现及转让，敬请知悉。"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" ·流量充值仅适用于本机自带流量卡，不支持其他运营商流量卡，如需给其他流量卡充值，需要到运营商平台自行充值。"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" ·本流量卡严禁拔插至其他设备使用，一经检测将自动锁卡，由此产生的后果由用户自行承担。"),
    /*#__PURE__*/_createElementVNode("br")
  ])
], -1))
const _hoisted_19 = { class: "agreementCheck" }
const _hoisted_20 = { class: "ConfirmationPurchase" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, "支付", -1))
const _hoisted_22 = { style: {"display":"flex","justify-content":"space-between","margin-top":"20px"} }

import wx from "weixin-js-sdk-ts";
  import { Checkbox as VanCheckbox, showDialog, showToast } from "vant";
  import { ref, onMounted } from "vue";
  import {
    postOrderPackage,
    getAgainOrder,
    getCloseAgainOrder
  } from "@/api";
  import { useRoute, useRouter } from "vue-router";
  import { setWxConfig } from "@/utils";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'packageInfo',
  setup(__props) {

  const route = useRoute()
  const router = useRouter()
  let againPackageName = ref(); /* 二次支付的套餐名 */
  let againOrderNo = ref(); /* 二次支付的订单号 */
  let againPurchaseShow = ref(false);
  const hasAgreed = ref(false);

  const sourceQuery = () => route.query.source === 'watchHome' ? { source: 'watchHome' } : {}

  function goPurchaseSuccess() {
    router.push({
      name: "packageSucceeds",
      params: {
        iccid: packageInfo.value.iccid,
      },
      query: sourceQuery()
    });
  }

  //提交订单
  function submitOrder() {
    if (!hasAgreed.value) {
      showToast("请先勾选已阅读并同意");
      return;
    }
    let params = {
      packageId: packageInfo.value.packageId,
      appId: sessionStorage.getItem("appId"),
      iccid: packageInfo.value.iccid,
      userId: sessionStorage.getItem("userId"),
    };
    postOrderPackage(params).then((res: any) => {
      if (res.code == 200) {
        // const { payInfo } = res.result;
        // const { payInfo } = res.result;
        // window.location.href = payInfo;
        wx.chooseWXPay({
          // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
          timestamp: res.result.payInfo.timeStamp,
          // 支付签名随机串，不长于 32 位
          nonceStr: res.result.payInfo.nonceStr,
          // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
          package: res.result.payInfo.package,
          // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
          signType: res.result.payInfo.signType,
          // 支付签名
          paySign: res.result.payInfo.paySign,
          appId: res.result.payInfo.appId,
          // 支付成功后的回调函数
          success: function () {
            // res.errMsg === 'chooseWXPay:ok'方式判断前端返回,微信团队郑重提示：
            // res.errMsg将在用户支付成功后返回ok，但并不保证它绝对可靠， 切记。
            goPurchaseSuccess();
          },
        });
      } else {
        if (res.code == 214) {
          againPurchaseShow.value = true;
          againPackageName.value = res.message.split("|")[1];
          againOrderNo.value = res.message.split("|")[0];
        } else {
          showDialog({
            message: res.message,
          }).then(() => {
            // on close
          });
        }
      }
    });
  }
  //二次支付
  function againSubmitOrder() {
    againPurchaseShow.value = false;
    let params = {
      orderNo: againOrderNo.value,
    };
    getAgainOrder(params).then((res: any) => {
      if (res.code == 200) {
        // const { payInfo } = res.result;
        // window.location.href = payInfo;
        wx.chooseWXPay({
          // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
          timestamp: res.result.payInfo.timeStamp,
          // 支付签名随机串，不长于 32 位
          nonceStr: res.result.payInfo.nonceStr,
          // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
          package: res.result.payInfo.package,
          // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
          signType: res.result.payInfo.signType,
          // 支付签名
          paySign: res.result.payInfo.paySign,
          appId: res.result.payInfo.appId,
          // 支付成功后的回调函数
          success: function () {
            // res.errMsg === 'chooseWXPay:ok'方式判断前端返回,微信团队郑重提示：
            // res.errMsg将在用户支付成功后返回ok，但并不保证它绝对可靠， 切记。
            goPurchaseSuccess();
          },
        });
      } else {
        showToast(res.message);
      }
    });
  }
  //取消二次支付
  function againCancelOrder() {
    againPurchaseShow.value = false;
    let params = {
      orderNo: againOrderNo.value,
    };
    getCloseAgainOrder(params).then((res: any) => {
      if (res.code == 200) {
        showToast("取消成功");
      } else {
        showToast(res.message);
      }
    });
  }
  let packageInfo: any = ref();
  onMounted(() => {
    packageInfo.value = JSON.parse(<string>route.params.data);
  })
  setWxConfig(["chooseWXPay"]);

return (_ctx: any,_cache: any) => {
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_unref(packageInfo))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("ul", _hoisted_2, [
          _createElementVNode("li", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(packageInfo).agentPackageName), 1)
          ]),
          _createElementVNode("li", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(packageInfo).boundlessFlag ? '专用高速网络通道': '共享高速网络通道'), 1)
          ]),
          _createElementVNode("li", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(packageInfo).boundlessFlag ? '随心用' : `${_unref(packageInfo).cmeFlowCount.split(".")[0]}${Number(_unref(packageInfo).cycleType) === 3 ? 'GB/月' : 'GB总流量使用数'}`), 1)
          ]),
          _createElementVNode("li", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, "￥" + _toDisplayString(_unref(packageInfo).packageOriginalPrice), 1)
          ]),
          _createElementVNode("li", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("div", _hoisted_17, "￥" + _toDisplayString(_unref(packageInfo).agentSalePrice), 1)
          ]),
          _hoisted_18
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_unref(VanCheckbox), {
            modelValue: hasAgreed.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((hasAgreed).value = $event)),
            "icon-size": "16px"
          }, {
            default: _withCtx(() => [
              _createTextVNode("已阅读并同意")
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createVNode(_component_van_button, {
          type: "primary",
          disabled: !hasAgreed.value,
          onClick: _withModifiers(submitOrder, ["prevent"]),
          class: "payBtn"
        }, {
          default: _withCtx(() => [
            _createTextVNode("立即充值")
          ]),
          _: 1
        }, 8, ["disabled", "onClick"]),
        _createVNode(_component_van_popup, {
          show: _unref(againPurchaseShow),
          "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => (_isRef(againPurchaseShow) ? (againPurchaseShow).value = $event : againPurchaseShow = $event)),
          round: "",
          style: { padding: '30px', height: '200px', width: '85%' }
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _createElementVNode("div", null, "您有一笔未支付订单：" + _toDisplayString(_unref(againPackageName)) + "！", 1),
              _createElementVNode("div", _hoisted_22, [
                _createVNode(_component_van_button, {
                  color: "#DCDEE0",
                  block: "",
                  onClick: againCancelOrder
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("关闭订单")
                  ]),
                  _: 1
                }),
                _createVNode(_component_van_button, {
                  color: "#6aafff",
                  block: "",
                  style: {"margin-left":"10px"},
                  onClick: againSubmitOrder
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("再次支付")
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        }, 8, ["show"])
      ]))
    : _createCommentVNode("", true)
}
}

})